import { submitFormToHubspot } from '../../../util/helpers/hubspot';

export interface HubspotContactValues {
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
}

export const submitHubspotContactToForm = async ({ firstname, lastname, email, phone }: HubspotContactValues) => {
  const fields = [
    { name: 'firstname', value: firstname },
    { name: 'lastname', value: lastname },
    { name: 'email', value: email },
    { name: 'phone', value: phone }
  ];

  // TODO: Have function return void if we're in dev environment after proper QA testing

  return await submitFormToHubspot('6d8d773a-5c56-44b4-be97-931d1cfa93cf', fields);
};
